import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { SpinnerComponent } from '@navstation-portal/shared/ui/components';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'nsp-loading-overlay',
  standalone: true,
  templateUrl: './loading-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SpinnerComponent, ButtonModule],
})
export class LoadingOverlayComponent {
  readonly isLoading = input.required<boolean>();

  readonly showLongLoadingWarning = signal(false);

  private timeoutId?: number;
  private readonly timeoutMs = 120000;

  constructor() {
    effect(() => {
      if (this.timeoutId) clearTimeout(this.timeoutId);

      if (this.isLoading()) {
        this.showLongLoadingWarning.set(false);

        this.timeoutId = window.setTimeout(() => {
          this.showLongLoadingWarning.set(true);
        }, this.timeoutMs);
      } else {
        this.showLongLoadingWarning.set(false);
      }
    });
  }

  reloadPage(): void {
    window.location.reload();
  }
}
